import { Inject } from "typescript-ioc";
import { Input } from "./Input";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { EventBinder } from "Events/Scripts/EventBinder";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";

export class Hidden extends Input {
    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory
    ) {
        super(componentFactory, binder, loggerFactory);
    }

    /**
     * UI component's context element in the DOM.
     */
    public get context(): HTMLInputElement {
        return this.getContextAs(HTMLInputElement, "hidden");
    }
}
